app.service(
    'TranslateService', ['$translate', '$stateParams', '$rootScope', TranslateService]
);

function TranslateService($translate, $stateParams, $rootScope) {
    this.use = function use(lang) {
        var modedebugTransalte = $rootScope.globals.debugTranslate;
        if (modedebugTransalte == "true") {
            //set no fallback
            $translate.fallbackLanguage(['key']);
            $translate.use("xx");
        }
        else {
            $translate.use(lang);
        }
    };
}